var render = function render(){var _vm=this,_c=_vm._self._c;return _c('layout',{attrs:{"session":_vm.session,"participant":_vm.participant}},[_c('div',{staticClass:"mt-12 sm:mt-0 px-4 py-5 text-center"},[_c('div',{staticClass:"min-w-0 flex-1 h-full max-w-sm mx-auto lg:order-last px-3 select-none"},[_c('img',{staticClass:"w-3/5 sm:w-4/5 mx-auto my-12",attrs:{"src":"/img/participate.png"}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }